export default {
  inserted(el, binding) {
    const defaultOptions = {
      exitDelay: 0,
      interval: 100,
      sensitivity: 7,
    }
    let config = {}

    let currX
    let currY
    let prevX
    let prevY
    let pollTimer
    let exitTimer

    // override default options with user config
    const extend = (defaults, userArgs) => {
      return {
        ...defaults,
        ...userArgs,
      }
    }

    // update mouse position
    const mouseTrack = (ev) => {
      currX = ev.pageX
      currY = ev.pageY
    }

    // check if mouse movement has slowed enough to trigger active state
    const mouseCompare = (targetElem, ev) => {
      const distX = prevX - currX
      const distY = prevY - currY
      const distance = Math.sqrt(distX * distX + distY * distY)

      if (distance < config.sensitivity) {
        /**
         * if we re-entered an element,
         * cancel delayed exit and clear any active elements immediately
         */
        clearTimeout(exitTimer)

        if (targetElem.isActive) {
          config.onExit(targetElem)
          targetElem.isActive = false
        }

        // trigger hover
        config.onEnter(targetElem)
        targetElem.isActive = true
      } else {
        // update previous coordinates and try again later
        prevX = currX
        prevY = currY
        pollTimer = setTimeout(() => {
          mouseCompare(targetElem, ev)
        }, config.interval)
      }
    }

    const init = (elem, userConfig) => {
      if (!userConfig || !userConfig.onEnter || !userConfig.onExit) {
        // throw 'onEnter and onExit callbacks must be provided'
        return
      }
      config = extend(defaultOptions, userConfig)

      elem.isActive = false
      // keeps track of mouse position
      elem.addEventListener('mousemove', mouseTrack)

      elem.addEventListener('mouseenter', (ev) => {
        // set initial entry position
        prevX = ev.pageX
        prevY = ev.pageY
        // if this element is already active, cancel exit
        if (elem.isActive) {
          clearTimeout(exitTimer)
          return
        }

        // while mouse is over this element, check distance every 100ms
        pollTimer = setTimeout(() => {
          mouseCompare(elem, ev)
        }, config.interval)
      })
      elem.addEventListener('mouseleave', () => {
        clearTimeout(pollTimer)
        if (!elem.isActive) return

        exitTimer = setTimeout(() => {
          config.onExit(elem)
          elem.isActive = false
        }, config.exitDelay)
      })
    }

    init(el, binding.value)
  },
}
